export default __webpack_public_path__ + "static/media/disable-tick.30daca7a.svg";